import { MapPin } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

/** Says where on or off campus comes from: the school's public IP addresses, under Administration › Settings. */
export function CampusNetworkNote({ children }: { children: ReactNode }) {
  return (
    <div className="flex gap-3 rounded-lg border border-slate-200 p-4 text-sm text-slate-600">
      <MapPin className="mt-0.5 size-4 shrink-0 text-slate-400" />
      <p>
        {children} Your school’s addresses are under{' '}
        <Link to="/settings" className="font-medium text-brand-700 hover:underline">
          Administration › Settings
        </Link>
        .
      </p>
    </div>
  );
}
